import React, { useEffect, useMemo, useState } from 'react';
//import './ViewControl.scss';
import 'react-json-pretty/themes/monikai.css';
import _ from 'lodash';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';



let viewControlIdCounter = 0;

const ViewControl = ({dialogState, itemManager,metadataItem,item,onClose}) => {

    const titleId = useMemo(() => `view-control-title-${++viewControlIdCounter}`, []);
    const [fields,setFields] = useState([]);
    const [title,setTitle] = useState("");
    const [description,setDescription] = useState(""); 
    
     useEffect(()=>{
        resetView();
     },[item,metadataItem,itemManager]);

     const resetView =() => {
         if(item){
            setFields(_.sortBy(metadataItem?.Fields ?? [],x=>x.DisplaySequence));
            setTitle(metadataItem?.Name ?? "");
            setDescription(metadataItem?.Description ?? "");
         }
         else{
            setFields([]);
            setTitle("");
            setDescription("");
         }
     };

    const handleClose = ()=>{
        onClose();
    }

    const renderFieldElement=(field,item)=>{
        if(item){

            if(typeof(item[field.FieldName]) === "object"){
                return (
                    _.map(item[field.FieldName],(value,key)=>(
                <div key={"field_item_" + field.FieldName + "_" + key }>
                      &nbsp;&nbsp;&nbsp;{key}:&nbsp;{value.toString()}
                </div>)))
            }
            else{
             return (<span key={"field_item_" + field.FieldName}>
                       :&nbsp;{itemManager.formatFieldValue(field,item[field.FieldName])}
                </span>)
            }
        }
        else
            return;
    }

    const renderField=(field,item)=>{
        return (
            <div key={"field_" + field.FieldName}>
                <span>{field.DisplayName}</span>{renderFieldElement(field,item)}
            </div>
        );
    }

    const renderFields = () => {
        return (
            <div key="fields">
                {_.map(fields,field=> renderField(field,item))}
            </div>
        );
    }

    const renderDialog =  (<Dialog open={dialogState==="view"} onClose={handleClose} aria-labelledby={titleId}>
            <DialogTitle id={titleId}>View {title}</DialogTitle>
            <DialogContent>
            <DialogContentText>
               {description}
            </DialogContentText>
            {renderFields()}
            </DialogContent>
            <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            </DialogActions>
    </Dialog>)
    return renderDialog;
}

export default ViewControl;
